export const environment = {
    production: true,
    hmr: false,
    gqlUrl: 'https://gql.spekwo.com/graphql',
    website: 'https://www.spekwo.com/',
    displayWebsite: 'www.spekwo.com',
    email: 'prohelp@spekwo.com',
    apiHost: 'https://api.spekwo.com/',
    profileUrl: 'https://api.spekwo.com/profiles/',
    logoUrl: 'https://api.spekwo.com/logos/',
    picStories: 'https://.api.spekwo.com/PictureStories/',
    phoneNumber: '866.646.0200'
};



// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/environments/environment.ts